import { NotificationAlertOverride } from ".";
import { AnyNotificationContext } from "../../Notifications";

export const TaxVerified: NotificationAlertOverride<
  AnyNotificationContext
> = () => ({
  theme: "success",
  icon: "check-circle"
});
